/* eslint no-shadow: ["error", { "allow": ["state"] }]	*/
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
	joinedCourse: false,
	lessonIds: [],
	userCourses: []
};

const getters = {
	getJoinedStatus: (state) => {
		return state.joinedCourse;
	},
	getLessonIds: (state) => {
		return state.lessonIds;
	},
	getUserCourses: (state) => {
		return state.userCourses;
	}
};

const mutations = {
	resetJoinedCourse: (state) => {
		state.joinedCourse = false;
	},
	setJoinedCourse: (state, payload) => {
		state.joinedCourse = payload;
	},
	setLessonIds: (state, payload) => {
		state.lessonIds = payload;
	},
	setUserCourses: (state, payload) => {
		state.userCourses = payload;
	},
	updateUserCourses: (state, payload) => {
		state.userCourses = [...state.userCourses, payload];
	}
};


export default {
	state,
	getters,
	mutations
};
